@if (item) {
  <div class="flex flex-col h-full overflow-x-hidden">
    <div class="result-item-header sticky">
      <div class="flex items-center p-1 gap-2 border-bottom">
        <button
          (click)="onToggleShowFacetList()"
          [title]="
            (showFilters$ | async)
              ? ('catalog.result.hide_filters' | transloco)
              : ('catalog.result.show_filters' | transloco)
          "
          id="catalog_result_btn_toggle-facet-list"
          mat-button
          class="shrink-0"
        >
          <mat-icon>filter_alt</mat-icon>
          <span class="result-count font-bold" id="catalog_result_txt_found-records">{{
              item.search.found
            }}</span>
        </button>
        <mat-divider vertical class="h-[16px]"></mat-divider>
        <button
          (click)="onCopyResultSearch()"
          [title]="'catalog.result.copy_search_query_btn' | transloco"
          id="catalog_result_btn_copy-search-result-query"
          class="primary-icon-button"
          mat-icon-button
        >
          <mat-icon>content_copy</mat-icon>
        </button>
        <button
          (click)="onEditResultSearch(item)"
          [title]="'catalog.result.edit_search_result_btn' | transloco"
          id="catalog_result_btn_edit-search-result-query"
          mat-icon-button
        >
          <mat-icon>find_in_page</mat-icon>
        </button>
        <div class="hidden lg:block">
          <cat-ui-form-query [searchItem]="item"></cat-ui-form-query>
        </div>
        <!--
        <button (click)="onOpenDynamicGallery()" *ngIf="hasDynamicGallery" mat-icon-button>
          <fa-icon [icon]="dynamicGalleryIcon"></fa-icon>
        </button>
        -->
      </div>
    </div>
    <mat-drawer-container class="result-facet-container h-full">
      <mat-drawer-content class="bg-white">
        <cat-result-list [resultListMode]="resultListMode$ | async" [searchItem]="item"></cat-result-list>
      </mat-drawer-content>
      <mat-drawer [style.width]="filterSidenavWidth" [style.max-width]="'100%'" [opened]="showFilters$ | async"
                  mode="over"
                  position="start">
        <cat-facet-container [searchItem]="item" class="grow"></cat-facet-container>
      </mat-drawer>
    </mat-drawer-container>
  </div>
}
